import { render, staticRenderFns } from "./RewardCategory.vue?vue&type=template&id=b9b2765a"
import script from "./RewardCategory.vue?vue&type=script&lang=js"
export * from "./RewardCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports